<rask-fieldset-toggle
  [formGroup]="form"
  label="Handelssortiment"
  [defaultExpanded]="open"
  [nrOfSelectedFilters]="filterLength">
  @if (items) {
    <rask-tree-selector
      class="w-100"
      label="Handelssortiment"
      (change)="selectionChanged()"
      [items]="items">
    </rask-tree-selector>
  }
</rask-fieldset-toggle>
